const GENERIC_CONTAINER_BILLING_UNIT_NAMES = new Set(['箱', 'box', 'container'])

export interface GenericContainerBillingUnitLike {
  unitNameCn?: unknown
  unitNameEn?: unknown
  nameCn?: unknown
  nameEn?: unknown
  billingUnitNameCn?: unknown
  billingUnitNameEn?: unknown
  content?: GenericContainerBillingUnitLike | null
}

/** 判断名称是否为通用“箱”计费单位，兼容历史英文名 Box。 */
export const isGenericContainerBillingUnitName = (value: unknown): boolean => {
  if (typeof value !== 'string') return false
  return GENERIC_CONTAINER_BILLING_UNIT_NAMES.has(value.trim().toLowerCase())
}

/** 判断计费单位对象是否为通用“箱”计费单位。 */
export const isGenericContainerBillingUnit = (unit?: GenericContainerBillingUnitLike | null): boolean => {
  if (!unit) return false
  const candidates = [unit, unit.content].filter(Boolean) as GenericContainerBillingUnitLike[]
  return candidates.some(item => [
    item.unitNameCn,
    item.unitNameEn,
    item.nameCn,
    item.nameEn,
    item.billingUnitNameCn,
    item.billingUnitNameEn
  ].some(isGenericContainerBillingUnitName))
}
